import { METRIC_IDS } from '../analytics';

export const convertMetricNameToId = (name: string) =>
  name
    .toLowerCase()
    .replace(/'/g, '')
    .replace(/ /g, '_')
    .replace(/-/g, '_') as METRIC_IDS;
